import React, { useState } from "react"
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  LayoutAnimation,
  Platform,
  UIManager
} from "react-native"
import { Feather } from "@expo/vector-icons"
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard"


interface Props {
  title: string
  count?: number
  children: React.ReactNode
}

export default function AccordionSection({
  title,
  count,
  children
}: Props) {

  const [open, setOpen] = useState(false)

  const toggle = () => {
    LayoutAnimation.configureNext(
      LayoutAnimation.Presets.easeInEaseOut
    )
    setOpen(!open)
  }

  return (
    <View style={styles.wrapper}>

      {/* HEADER */}
      <TouchableOpacity
        style={styles.header}
        onPress={toggle}
        activeOpacity={0.8}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text style={styles.title}>{title}</Text>
          {count !== undefined && (
            <View style={styles.badge}>
              <Text style={styles.badgeText}>{count}</Text>
            </View>
          )}
        </View>

        <Feather
          name={open ? "chevron-up" : "chevron-down"}
          size={20}
          color={COLORS.primary}
        />
      </TouchableOpacity>

      {/* CONTENT */}
      {open && (
        <View style={styles.content}>
          {children}
        </View>
      )}

    </View>
  )
}

const styles = StyleSheet.create({

  wrapper: {
    backgroundColor: "#fff",
    borderRadius: 16,
    marginBottom: 25,
    borderWidth: 1,
    borderColor: "#F3F4F6",
    overflow: "hidden"
  },

  header: {
    padding: 18,
    backgroundColor: "#F9FAFB",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: {
    fontSize: 16,
    fontWeight: "700",
    color:COLORS.primary
  },

  badge: {
    marginLeft: 10,
    backgroundColor: "#E9D8F7",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 20,
  },

  badgeText: {
    color:COLORS.primary,
    fontSize: 12,
    fontWeight: "600",
  },

  content: {
    padding: 4,
  },

})
